import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_AccPageHeader = _resolveComponent("AccPageHeader")!
  const _component_AppStartupComponent = _resolveComponent("AppStartupComponent")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_AccPageRightNav = _resolveComponent("AccPageRightNav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, {
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { "nav-title": "" }, "Startups", -1)
        ]))]),
        right: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        bottom: _withCtx(() => [...(_cache[2] || (_cache[2] = []))]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      (_ctx.user)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_AccPageHeader, { padded: true }, {
              icon: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_OfficeBuilding, { primary: "" })
                  ]),
                  _: 1
                })
              ]),
              content: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", null, " Startups/ Businesses that you are a founder/co-founder of! ", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_el_space, {
                size: 14,
                fill: "",
                "w-100": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessesData.resources, (business) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `busess-${business._id}`
                    }, [
                      _createVNode(_component_AppStartupComponent, { business: business }, null, 8, ["business"])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_tooltip, { content: "Click to create another startup with you as a founder" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    "m-tb-3": "",
                    onClick: _ctx.createStartup,
                    type: "primary",
                    "is-block": "",
                    plain: "",
                    size: "large",
                    "is-borderless": "",
                    icon: "el-icon-plus"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Create Another Startup Profile ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_AccPageRightNav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}